import Dispatcher from "../dispatcher";

export default {
  setCurrentMarker(marker) {
    Dispatcher.emit(Dispatcher.MARKERS_SET_CURRENT, marker);
  }
};
